export default __webpack_public_path__ + "static/media/globalOil.a1ac6266.png";